import React from 'react'
import Modal from './modal'
import hooks from '../../../hooks'
import ErrorModal from '../../modals/error'

const UserReflectionScreen = () => {
    const { id: currentUserId, isAdmin, isFacilitator } = hooks.useCurrentUser()
    const { params, goBack } = hooks.useClientLocation()
    const userId = params.userId
    const promptId = params.promptId

    if (userId !== currentUserId && !isAdmin && !isFacilitator) {
        return (
            <ErrorModal onHide={() => goBack()} title='Unauthorized'>
                You cannot view this reflection
            </ErrorModal>
        )
    }

    if (!userId || !promptId) {
        return null
    }

    return (
        <React.Fragment>
            <Modal
                onHide={goBack}
                userId={userId}
                promptId={promptId}
            />
        </React.Fragment>
    )

}

export default UserReflectionScreen